module.exports = __webpack_public_path__ + "img/nav-right-search-below-mitsu.3c23744c.png";